import { ComponentPropsWithoutRef } from 'react';

export const PhoneIconV2 = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 13 13" fill="none">
      <path
        d="m9.074 8.105-.303.302s-.722.717-2.692-1.242C4.109 5.207 4.831 4.49 4.831 4.49l.19-.19c.472-.468.517-1.22.105-1.77l-.84-1.122c-.509-.68-1.492-.77-2.076-.19l-1.046 1.04c-.289.288-.482.66-.459 1.074.06 1.058.539 3.333 3.208 5.988 2.831 2.814 5.488 2.926 6.574 2.825.344-.032.643-.207.883-.447l.947-.941c.64-.635.46-1.725-.359-2.17l-1.273-.693a1.36 1.36 0 0 0-1.61.212Z"
        fill="#000000"
      />
    </svg>
  );
};
